import React from 'react';
import './Header.css';
import btwbLogo from '../../Assets/btwb_logo.svg';
import otherLogo from '../../Assets/rogue-logo.png';

function Header() {
	return(<header className="header relative">
		{/*<div className="header-img absolute w-100 h-100"></div>*/}
		<div className="super-header absolute top-0 mt0 ph3 pt2  w-100 white flex items-center">
			<div className="tl w-50">
				<a href="https://btwb.com">
					<img className="logo" src={btwbLogo} alt="btwb logo" width="133" />
				</a>
			</div>
			<div className="tr w-50 rogue">
				<a href="https://www.roguefitness.com/dont-weaken">
					<img className="logo" alt="rogue logo" src={otherLogo} width="200" />
				</a>
			</div>
		</div>
	</header>)
}

export default Header;